import { isEmpty, get } from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import UserManagementConstants from '../constants/UserManagementConstants';
import UserManagementApiUtils from '../utils/UserManagementApiUtils';
import {
  BUSINESS_CUSTOMER,
  NOMINATED_USER,
  ADDITIONAL_USER,
  CORPORATE_ADMIN,
  PRIVATE_USER,
} from '../constants/UserSegmentConstants';
import { loadChatBot } from '../chatbot/loadChatBot';

let hasUserRead = false;
let error = undefined;
let caDetails = {};
let isLoaded = false;
let isManageDevice = false;
let isMTrackUserEnabled = false;
let isLiveChatMounted = false;

class UserManagementStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  isUserReadEnabled() {
    return hasUserRead;
  }
  isCorporateAdmin() {
    return this.isBusinessUser() && caDetails.sub_segment === CORPORATE_ADMIN;
  }
  isNominatedUser() {
    return caDetails.sub_segment === NOMINATED_USER;
  }
  isAdditionalUser() {
    return caDetails.sub_segment === ADDITIONAL_USER;
  }
  isPrivateUser() {
    return caDetails.segment === PRIVATE_USER;
  }
  isSMEUser() {
    return (
      caDetails.segment === BUSINESS_CUSTOMER &&
      (caDetails.sub_segment === ADDITIONAL_USER ||
        caDetails.sub_segment === CORPORATE_ADMIN)
    );
  }
  isCA() {
    return (
      caDetails.segment === BUSINESS_CUSTOMER &&
      caDetails.sub_segment === CORPORATE_ADMIN
    );
  }
  isBusinessUser() {
    return caDetails.segment === BUSINESS_CUSTOMER;
  }
  isManageDeviceEnabled() {
    return isManageDevice;
  }
  isCaDetailsUndefined() {
    return isEmpty(this.getCADetails());
  }
  getCADetails() {
    return caDetails;
  }
  getUserDetailsLoad() {
    return isLoaded;
  }
  getUMServiceError() {
    return error;
  }
  isMTrackUserEnabled() {
    return isMTrackUserEnabled;
  }
  isLiveChatMounted() {
    return isLiveChatMounted;
  }
  unmountLiveChat() {
    isLiveChatMounted = false;
  }
  dispatcherCallback({ action }) {
    const actionType = action.actionType;
    const actionData = action.data;
    switch (actionType) {
      case UserManagementConstants.REQUEST_USER_DETAILS:
        isLoaded = false;
        UserManagementApiUtils.getUserDetails();
        break;
      case UserManagementConstants.REQUEST_USER_DETAILS_SUCCESS:
        isLoaded = true;
        caDetails = actionData;
        const { customers } = caDetails;
        if (customers && customers.length > 0) {
          hasUserRead = customers[0].actions_available['/users/read'];
          isManageDevice =
            customers[0].actions_available['/users/device/manage'];
          isMTrackUserEnabled =
            customers[0].actions_available['/account/mtrack/access'];
        }
        if (this.isLiveChatMounted() === false) {
          try {
            loadChatBot();
            isLiveChatMounted = true;
          } catch (e) {}
        }
        this.emitChange();
        break;
      case UserManagementConstants.REQUEST_USER_DETAILS_ERROR:
        isLoaded = true;
        error = actionData;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new UserManagementStore();
